module.exports = __webpack_public_path__ + "sedacollege.jpg?9a38934f142989732c239d426c4d4aee";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projetos/sedacollege.jpg
// module id = 153
// module chunks = 0